import { render, staticRenderFns } from "./IconProofread.vue?vue&type=template&id=6767ff84&"
import script from "./IconProofread.vue?vue&type=script&lang=js&"
export * from "./IconProofread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6767ff84')) {
      api.createRecord('6767ff84', component.options)
    } else {
      api.reload('6767ff84', component.options)
    }
    module.hot.accept("./IconProofread.vue?vue&type=template&id=6767ff84&", function () {
      api.rerender('6767ff84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconProofread.vue"
export default component.exports